import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const OrderBookInfo = ({ orderInfo, chance }) => {
  return (
    <>
      <Box sx={{ mt: 1, px: 2 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              프로젝트 번호
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.prjNo}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              프로젝트명
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.prjNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              매출처
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.partnerNm}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              계약일
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.expDay}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              계약완료일
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.siDt}
            </Typography>
          </Grid>
          {chance?.prjTyp === 'N' && (
            <>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  무상 유지보수 기간(개월)
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {orderInfo?.mtnFreeTm} 개월
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              수금조건
            </Typography>
          </Grid>
          <Grid item xs={chance?.prjTyp === 'N' ? 3 : 5}>
            <Typography variant="body2" component="div">
              {orderInfo?.collCondt}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              지급조건
            </Typography>
          </Grid>
          <Grid item xs={chance?.prjTyp === 'N' ? 3 : 5}>
            <Typography variant="body2" component="div">
              {orderInfo?.payCondt}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
            납품예정일
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.dlvryDuedate}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              검수조건
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.inspectCond}
            </Typography>
          </Grid>

          {chance?.prjTyp === 'N' && (
            <>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  무상 유지보수 기간
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {orderInfo?.mtnFreeStrtDt}~{orderInfo?.mtnFreeEndDt}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
            <Grid item xs={1}>
                <Typography variant="subtitle2" component="div">
                  라이센스 기간 
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="body2" component="div">
                  {orderInfo?.licStrtDt} ~ {orderInfo?.licEndDt}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography variant="subtitle2" component="div">
                보증보험
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" component="div">
                 선급금 비율 : {orderInfo?.giPrePct} / 계약이행 비율 : {orderInfo?.giCovPct} / 하자유지보수 비율 : {orderInfo?.giMtnPct}  
                </Typography>
              </Grid>
 
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              참고사항
            </Typography>
          </Grid>
          <Grid item xs={11}>
            <Typography
              sx={{ whiteSpace: 'pre-line' }}
              variant="body2"
              component="div"
            >
              {orderInfo?.comment}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default OrderBookInfo;
